<div class="h-1 border-b border-gray-200" *ngIf="!showSelectedItems">
    <mat-progress-bar *ngIf="!loaded" mode="indeterminate"></mat-progress-bar>
</div>
<div class="flex items-center py-4 pl-2 border-b" *ngIf="showSelectedItems">
    <button class="mr-1" mat-icon-button (click)="hideSelectedItemsPanel()">
        <em class="ti ti-arrow-narrow-left icon-size-7 text-gray-500"></em>
    </button>
    <div class="ml-1 flex items-center">
        <span class="text-lg">{{'dataPicker.job.selected_job' | translate}}</span>
        <badge class="ml-2" [options]="getBadgeOptions()">
        </badge>
    </div>
</div>
<ul role="list" class="divide-y divide-gray-200 overflow-y-auto zuper-scrollbar data-picker-list-content-height"
    *ngIf="jobs.length">
    <li class="job-data-picker-list-ele" *ngFor="let job of jobs">
        <div class="hover:bg-gray-50 group relative flex items-center py-3 px-5"
            [ngClass]="{'cursor-pointer': selectOption === 'readOnly'}"
            (click)="selectOption === 'readOnly' ? viewJobDetails($event, job) : null">
            <a class="-m-1 block flex-1 p-1">
                <div class="relative flex min-w-0 flex-1 items-center">
                    <mat-checkbox (change)="selectJob($event, job)" *ngIf="selectOption === 'multiSelect'" #checkboxRef
                        [disabled]="validateSelectionDisable(job)" [checked]="isSelectedJob(job)" color="primary" disableRipple="true"
                        >
                        <!-- [matTooltip]="validateSelectionDisable(job) ? ('dataPicker.job.selection_disable.text' | translate) : null"
                        matTooltipPosition="below" -->
                        <div class="ml-4 truncate pointer-events-auto">
                            <ng-container *ngTemplateOutlet="jobsContent; context: {checkboxRef: checkboxRef}"></ng-container>
                        </div>
                    </mat-checkbox>
                    <mat-radio-button (change)="selectJob($event, job)" *ngIf="selectOption === 'select'"
                        [disabled]="validateSelectionDisable(job)" [checked]="isSelectedJob(job)" color="primary" disableRipple="true"
                        [matTooltip]="validateSelectionDisable(job) ? ('dataPicker.job.selection_disable.text' | translate) : null"
                        matTooltipPosition="below">
                        <div class="ml-4 truncate pointer-events-auto">
                            <ng-container *ngTemplateOutlet="jobsContent"></ng-container>
                        </div>
                    </mat-radio-button>
                    <ng-container *ngIf="selectOption === 'readOnly'">
                        <div class="truncate w-full pointer-events-auto">
                            <ng-container *ngTemplateOutlet="jobsContent"></ng-container>
                        </div>
                    </ng-container>
                    <ng-template #jobsContent let-checkboxRef="checkboxRef">
                        <div class="flex items-center justify-between">
                            <div class="w-full">
                                <div class="flex flex-row space-x-2 w-11/12">
                                    <p class="truncate text-lg font-medium text-gray-900 cursor-pointer flex items-center space-x-1.5">
                                        <span *ngIf="job?.route?.route_uid" title="{{'dispatchBoard.template.grid.route_job' | translate}}">
                                            <i class="ti ti-road text-2xl text-blue-700"></i>
                                        </span>
                                        <span *ngIf="job?.is_recurrence" title="{{'text.recurrent_job' | translate}}">
                                            <i class="ti ti-repeat text-2xl text-blue-700"></i>
                                        </span>
                                        <span *ngIf="job?.delayed_job" title="{{'text.delay_job' | translate}}">
                                            <i class="ti ti-alarm text-2xl text-red-700"></i>
                                        </span>
                                        <span *ngIf="job.prefix || job.work_order_number">
                                            {{ job.prefix ?? '' }}{{ job.work_order_number ?? '' }} -
                                        </span>
                                        <span>{{ job.job_title }}</span>
                                    </p>
                                </div>
                                <div class="flex flex-row space-x-2 mt-1" *ngIf="job?.job_category?.category_name && module !== 'RECURRENCE_JOB_MASTER'">
                                    <p class="truncate text-base text-gray-500" *ngIf="job?.job_category?.category_name">
                                        {{job?.job_category?.category_name}}
                                    </p>
                                </div>
                                <div class="flex flex-row space-x-2 mt-1" *ngIf="job?.job_count && module === 'RECURRENCE_JOB_MASTER'">
                                    <p class="truncate text-base text-gray-500" *ngIf="job?.job_count">
                                         {{'text.total_jobs' | translate | titlecase}}: {{job?.job_count}}
                                    </p>
                                </div>
                                <div class="flex flex-row space-x-2 mt-1 max-w-10/12" *ngIf="job?.rrule && module === 'RECURRENCE_JOB_MASTER'">
                                    <p class="truncate text-base text-gray-500 whitespace-normal" *ngIf="job?.rrule">
                                        {{'text.repeats' | translate | titlecase}} {{ getRRleAsString(job?.rrule) }}
                                    </p>
                                </div>
                                <div class="flex flex-row my-1 truncate text-base text-gray-500" *ngIf="job?.job_start">
                                    <p class="truncate text-base text-gray-500">{{job?.job_start | datetime: dateTimeFormat: timezone}}
                                        {{job?.job_end ? '
                                        - ' + (job?.job_end | datetime: dateTimeFormat + ' z': timezone) : ''}}</p>
                                </div>
                                <div class="flex flex-row my-1 truncate text-base text-gray-500" *ngIf="job?.scheduled_start_time">
                                    <p class="truncate text-base text-gray-500">{{job?.scheduled_start_time | datetime: dateTimeFormat: timezone}}
                                        {{job?.scheduled_end_time ? '
                                        - ' + (job?.scheduled_end_time | datetime: dateTimeFormat + ' (z)': timezone) : ''}}</p>
                                </div>
                                <div class="flex flex-row my-1 text-base primary-font font-normal"
                                    *ngIf="checkboxRef?.checked && dataConfig?.routeJobFromRouteWarning && job?.route?.route_uid && job?.route?.route_name && job?.route?.route_uid !== dataConfig?.routeUid">
                                    <p class="text-base text-amber-500 break-words w-full max-w-full whitespace-normal">{{'alert.remove_job_from_route' | translate}}: '{{job?.route?.route_name}}'</p>
                                </div>
                            </div>
                            <div class="ml-auto mr-4">
                                <em class="ti ti-alert-triangle icon-size-6 mr-5 text-red-500" *ngIf="getDisabledTex(job) !== ''"
                                    [title]="getDisabledTex(job)"></em>
                                <badge *ngIf="job?.current_job_status && job?.current_job_status?.status_name"
                                    [options]="getJobStatusOptions(job?.current_job_status)"></badge>
                            </div>
                        </div>
                    </ng-template>
                    <div class="flex ml-auto items-center h-full">
                        <div *ngIf="job?.conflict_count > 0 && module === 'RECURRENCE_JOB_MASTER'"
                            title="{{'text.conflicts' | translate}}: {{job?.conflict_count}}"
                            class="flex items-center justify-between p-1 py-0 text-amber-400 border-2 rounded-md border-yellow-200 bg-yellow-50 mr-2 cursor-pointer">
                            <i class="ti ti-alert-triangle-filled mr-1.5 text-2xl"></i>
                            <div class="count cursor-pointer">
                                {{job?.conflict_count > 20? '20+': job?.conflict_count}}
                            </div>
                        </div>
                        <button mat-icon-button class="cursor-pointer" matTooltip="{{ (this.jobEleId === 'job_details_' + job.job_uid ? this.localeKeys.collapse : this.localeKeys.expand) | translate }}"
                            matTooltipPosition="above" *ngIf="!((this.jobEleId === 'job_details_' + job.job_uid) && isSpinLoading)" [ngClass]="{'rotate-arrow-icon-down':this.jobEleId === 'job_details_' + job.job_uid,'rotate-arrow-icon-up':this.jobEleId !== 'job_details_' + job.job_uid}"
                            (click)="viewJobDetails($event, job)">
                            <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true" data-mat-icon-type="svg"
                                data-mat-icon-name="x" data-mat-icon-namespace="heroicons_outline">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chevron-down" width="24"
                                    height="24" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none"
                                    stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none">
                                    </path>
                                    <polyline points="6 9 12 15 18 9"></polyline>
                                </svg>
                            </mat-icon>
                        </button>
                        <div class="py-2.5 h-10 w-12" *ngIf="(this.jobEleId === 'job_details_' + job.job_uid ) && isSpinLoading">
                            <mat-spinner class="ml-auto data-picker-spinner md:mr-3" [diameter]="18" style="width: 18px;height: 18px">
                            </mat-spinner>
                        </div>
                    </div>
                </div>
            </a>
        </div>
        <div class="p-4 bg-gray-100"
            *ngIf="('job_details_' + job.job_uid === jobEleId) && jobDetails && !isSpinLoading">
            <div class="bg-card rounded relative">
                <a target="_blank" class="hidden" #jobViewFullDetails href="{{viewJobFullDetails(job)}}"></a>
                <span class="cursor-pointer absolute right-0 pt-1 pr-1 z-50" (click)="jobViewFullDetails.click($event)"
                    matTooltip="{{'text.view_details.new_tab' | translate}}" matTooltipPosition="left">
                    <button mat-icon-button (click)="setJobDetails(job)" >
                        <mat-icon class="text-xl">open_in_new</mat-icon>
                    </button>
                </span>
                <div class="text-base">
                    <div class="px-2 truncate grid grid-cols-2">
                        <div *ngIf="jobDetails.customer?.customer_first_name"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer job-details-fields dark:bg-hover">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'customer' | translate}}</p>
                            <p class="mt-1 text-gray-900"
                                *ngIf="jobDetails.customer?.is_deleted === true || !utilityService.hasModuleAccess('CUSTOMER')">
                                {{jobDetails.customer.customer_first_name}}
                                {{jobDetails.customer.customer_last_name ?? ''}}</p>
                            <p class="mt-1">
                                <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                                    [routerLink]="utilityService.getLink('CUSTOMER', jobDetails.customer.customer_uid)"
                                    *ngIf="!jobDetails.customer?.is_deleted && utilityService.hasModuleAccess('CUSTOMER')">
                                    {{jobDetails.customer.customer_first_name}}
                                    {{jobDetails.customer.customer_last_name ?? ''}}</a></p>
                        </div>
                        <div *ngIf="jobDetails?.job_category?.category_name && module === 'RECURRENCE_JOB_MASTER'"
                        class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer job-details-fields dark:bg-hover">
                        <p class="font-medium leading-5 truncate text-gray-500">
                            {{'category.text' | translate}}</p>
                        <p class="mt-1 text-gray-900"
                        *ngIf="jobDetails?.job_category?.category_name">
                            {{jobDetails?.job_category?.category_name}}</p>
                        </div>
                        <div *ngIf="jobDetails.organization"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer job-details-fields dark:bg-hover">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'text.organization_name' | translate}}</p>
                            <p class="mt-1 text-gray-900"
                                *ngIf="jobDetails.organization?.is_deleted === true || !utilityService.hasModuleAccess('ORGANIZATION')">
                                {{jobDetails.organization?.organization_name}}</p>
                            <p class="mt-1">
                                <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                                    [routerLink]="utilityService.getLink('ORGANIZATION', jobDetails.organization.organization_uid)"
                                    *ngIf="!jobDetails.organization?.is_deleted && utilityService.hasModuleAccess('ORGANIZATION')">
                                    {{jobDetails.organization?.organization_name}}</a>
                            </p>
                        </div>
                        <div *ngIf="jobDetails.property"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer job-details-fields dark:bg-hover">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'text.property' | translate}}</p>
                            <p class="mt-1 text-gray-900"
                                *ngIf="jobDetails.property?.is_deleted === true || !utilityService.hasModuleAccess('PROPERTY')">
                                {{jobDetails.property?.property_name}}</p>
                            <p class="mt-1">
                                <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                                    [routerLink]="utilityService.getLink('PROPERTY', jobDetails.property.property_uid)"
                                    *ngIf="!jobDetails.property?.is_deleted && utilityService.hasModuleAccess('PROPERTY')">
                                    {{jobDetails.property?.property_name}}</a>
                            </p>
                        </div>
                        <div *ngIf="jobDetails.job_priority"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer job-details-fields dark:bg-hover">
                            <p class="font-medium leading-5 truncate text-gray-500 mb-1">
                                {{'text.job_priority' | translate}}</p>
                            <badge class="m-2" [options]="getTagBadgeOptions(jobDetails?.job_priority)"
                                [matTooltip]="jobDetails?.job_priority" [matTooltipPosition]="'below'"></badge>
                        </div>
                        <div *ngIf="jobDetails.job_type"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer job-details-fields dark:bg-hover">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'text.job_type' | translate}}</p>
                            <p class="mt-1 text-gray-900">
                                {{jobDetails.job_type}}</p>
                        </div>
                        <div *ngIf="jobDetails.due_date"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer job-details-fields dark:bg-hover">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'due.date.text' | translate}}</p>
                            <p class="mt-1 text-gray-900">
                                {{jobDetails.due_date | dateformat: null : false : true : jobDetails?.job_timezone}}</p>
                        </div>
                        <div *ngIf="jobDetails.created_at"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer job-details-fields dark:bg-hover">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'created_on.text' | translate}}</p>
                            <p class="mt-1 text-gray-900">
                                {{jobDetails.created_at | datetime: dateTimeFormat: timezone }}</p>
                        </div>
                        <div *ngIf="jobDetails.created_by?.first_name"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer job-details-fields dark:bg-hover">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'created.by.text' | translate}}</p>
                            <p class="mt-1 text-gray-900">
                                {{jobDetails.created_by?.first_name}} {{jobDetails.created_by?.last_name ?? ''}}</p>
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="jobDetails?.conflict_count > 0 && this.module === 'RECURRENCE_JOB_MASTER'">
                    <div class="text-base">
                        <div class="px-2 truncate grid grid-cols-1">
                            <div>
                                <p class="font-medium leading-5 border-t truncate  ml-1 px-3 py-2">
                                    {{'text.conflicts' | translate}}: {{jobDetails?.conflict_count}} 
                                </p>
                                <div class="px-2 py-2 border-t text-base max-h-40 overflow-auto mb-3 border-b">
                                    <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer job-details-fields dark:bg-hover">
                                        <ng-container *ngFor="let conflict of jobDetails?.conflict; index as conflict_index">
                                            <div class="font-medium text-base primary-font" *ngIf="conflict?.conflictsData?.length > 0">
                                                {{conflict.type | titlecase}} {{'text.conflicts' | translate}}
                                                <ng-container *ngFor="let conflict_items of conflict?.conflictsData; index as conflict_items_index">
                                                    <div class="m-2 text-base primary-font font-normal text-gray-700 whitespace-pre-wrap"> {{conflict_items_index + 1}}.
                                                        {{conflict_items.message | titlecase}} </div>
                                                </ng-container>
                                                <hr *ngIf="conflict_index !== jobDetails?.conflict.length - 1">
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <div class="px-2 py-2 border-t text-base"
                    *ngIf="jobDetails.customer_address && (jobDetails.customer_address.street || jobDetails.customer_address.state)">
                    <p class="font-medium leading-5 truncate text-gray-500 mb-3 ml-3">
                        {{'text.service_address' | translate}} </p>
                    <div class="px-3">
                        <p *ngIf="jobDetails.customer_address.street" class="text-base mb-2">
                            {{jobDetails.customer_address.street}}</p>
                        <p *ngIf="jobDetails.customer_address.landmark" class="text-base mb-2">
                            {{jobDetails.customer_address.landmark}}</p>
                        <p *ngIf="jobDetails.customer_address.city" class="text-base mb-2">
                            {{jobDetails.customer_address.city}}</p>
                        <p *ngIf="jobDetails.customer_address.state" class="text-base mb-2">
                            {{jobDetails.customer_address.state}}
                            {{jobDetails.customer_address.zip_code ? '- ' +
                            jobDetails.customer_address.zip_code : '' }}</p>
                        <p *ngIf="jobDetails.customer_address.country" class="text-base">
                            {{jobDetails.customer_address.country}}</p>
                    </div>
                </div>
                <div class="px-2 py-2 border-t text-base"
                    *ngIf="jobDetails.customer_billing_address && (jobDetails.customer_billing_address.street || jobDetails.customer_billing_address.state)">
                    <p class="font-medium leading-5 truncate text-gray-500 mb-3 ml-3">
                        {{'billing.address.text' | translate}} </p>
                    <div class="px-3">
                        <p *ngIf="jobDetails.customer_billing_address.street" class="text-base mb-2">
                            {{jobDetails.customer_billing_address.street}}</p>
                        <p *ngIf="jobDetails.customer_billing_address.landmark" class="text-base mb-2">
                            {{jobDetails.customer_billing_address.landmark}}</p>
                        <p *ngIf="jobDetails.customer_billing_address.city" class="text-base mb-2">
                            {{jobDetails.customer_billing_address.city}}</p>
                        <p *ngIf="jobDetails.customer_billing_address.state" class="text-base mb-2">
                            {{jobDetails.customer_billing_address.state}}
                            {{jobDetails.customer_billing_address.zip_code ? '- ' +
                            jobDetails.customer_billing_address.zip_code : '' }}</p>
                        <p *ngIf="jobDetails.customer_billing_address.country" class="text-base">
                            {{jobDetails.customer_billing_address.country}}</p>
                    </div>
                </div>
            </div>
        </div>
    </li>
</ul>
<div class="overflow-hidden data-picker-list-content-height flex flex-col items-center justify-center"
    *ngIf="!jobs.length && loaded && !showSelectedItems">
    <div class="flex flex-col items-center justify-center">
        <img class="w-40 m-auto" src="assets/images/svgs/no_activity_found.svg" alt="No Jobs Found">
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="onSearch">{{'dataPicker.job.not_found' |
            translate}} '{{searchKey}}'</h4>
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="!onSearch">{{'dataPicker.job.placeholder' |
            translate}}
        </h4>
    </div>
</div>